const constants = {    

    ATUALIZA_MAILING: 'ATUALIZA_MAILING',
}

const initialState = {
    mailing: undefined,
};

export const mailingAction = {
    uploadMaliling: (mailing) => async(dispatch, getState) => {    
        dispatch({ type: constants.ATUALIZA_MAILING, mailing: mailing });  
    }
}

export const reducer = (state, action) => {

    state = state || initialState;

    switch (action.type)
    {
        case constants.ATUALIZA_MAILING:
            return {
                ...state,
                mailing: {mailing: action.mailing}
            };
        default:
            return state;
    }
}